<template>
  <content-layout :title="title" :head-image="headImage" :tabs="tabs" v-model="activeTab" :spin-show="spinShow">
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div class="activity-item mgui-container" slot="/costs/all">
      <div class="filter-row">
        <Row :gutter="10">
          <Col span="4">
            <Input v-model="filterItem.username" placeholder="姓名"></Input>
          </Col>
          <Col span="5">
            <Select v-model="filterItem.type" placeholder="选择类型">
              <Option value="all">所有类型</Option>
              <Option v-for="(item, key) in costsType" :key="key" :value="item">{{item}}</Option>
            </Select>
          </Col>
          <Col span="5">
            <DatePicker :options="dateOptions" v-model="filterItem.occur_at" type="daterange" style="width:100%" placeholder="选择日期"></DatePicker>
          </Col>
          <Col span="5">
            <Cascader v-model="filterItem.department_id" placeholder="选择项目组" :data="$store.state.department" @click="getDepartment" change-on-select></Cascader>
          </Col>
          <Col span="5">
            <Button type="primary" @click="filterCosts"><Icon type="md-search"></Icon> 筛选</Button>
          </Col>
        </Row>
      </div>
      <loading :visible="costsAll.length == 0" :text="costsAllTips"></loading>
      <Timeline>
        <TimelineItem v-for="(item, key) in costsAll" :key="key">
            <p class="time">{{outTime(item.created_at)}} <span style="color:#999">[ {{item.created_at}} ]</span></p>
            <div class="content">
              <Row class="cost-row">
                <Col :xs="{span:24, float:'right'}" :sm="24" :md="5"><h4>￥{{item.price}} 元</h4></Col>
                <Col :xs="12" :sm="12" :md="4">{{item.username}}</Col>
                <Col :xs="24" :sm="24" :md="4"><Tag>{{item.type}}</Tag></Col>
                <Col :xs="24" :sm="24" :md="6"><Tag>{{formatDepartment(item.department)}}</Tag></Col>
                <Col :xs="24" :sm="24" :md="5"><Tag>{{formatTime(item.occur_at)}}</Tag></Col>
              </Row>
            </div>
        </TimelineItem>
      </Timeline>
      <div class="pager" v-if="allPage.total>1">
        <Page :total="allPage.total" :page-size="15" @on-change="pagerAllChange" show-elevator></Page>
      </div>
    </div>
    <div class="activity-item mgui-container" slot="/costs">
      <div v-if="costs.length == 0">{{costsTips}}</div>
      <Timeline>
        <TimelineItem v-for="(item, key) in costs" :key="key">
            <p class="time">{{outTime(item.created_at)}} <span style="color:#999">[ {{item.created_at}} ]</span></p>
            <div class="content">
              <Row class="cost-row">
                <Col :xs="{span:24, float:'right'}" :sm="24" :md="8"><h4>￥{{item.price}} 元</h4></Col>
                <Col :xs="12" :sm="12" :md="8">{{item.type}}</Col>
                <Col :xs="24" :sm="24" :md="8"><i-tag>{{formatTime(item.occur_at)}}</i-tag></Col>
              </Row>
            </div>
        </TimelineItem>
      </Timeline>
      <div class="pager" v-if="page.total>1">
        <Page :total="page.total" :page-size="15" @on-change="pagerChange" show-elevator></Page>
      </div>
    </div>
    <div class="activity-item mgui-container" slot="/costs/post">
      <Form ref="formItem" :model="formItem" label-position="top" :rules="ruleData" class="costs-form">
        <FormItem label="姓名">
          <span class="ivu-input" disabled>{{$store.state.userInfo.username}}</span>
        </FormItem>
        <FormItem label="项目组">
          <Cascader :data="$store.state.department" @click="getDepartment" :value="setDepartment($store.state.userInfo.department_id)" disabled></Cascader>
        </FormItem>
        <FormItem label="产生时间" prop="occur_at">
          <DatePicker type="datetime" format="yyyy-MM-dd" :options="timeOptions" v-model="formItem.occur_at" placeholder="选择时间" style="width:100%;"></DatePicker>
        </FormItem>
        <FormItem label="金额" prop="price">
          <Input v-model="formItem.price">
            <span slot="append">元</span>
          </Input>
        </FormItem>
        <FormItem label="费用类型" prop="type">
          <Select v-model="formItem.type" style="width: 100%">
              <Option :value="item" :key="key" v-for="(item, key) in costsType">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem label="费用说明" prop="description">
          <Input v-model="formItem.description" type="textarea"></Input>
        </FormItem>
      </Form>
      <Poptip
        confirm
        placement="top-start"
        :width="300"
        title="请确认费用类型及金额，提交后不可修改!"
        @on-ok="submitCosts('formItem')">
        <Button type="primary" long>提交</Button>
      </Poptip>
    </div>
    <div class="activity-item mgui-container" slot="/costs/count">
      <costs-count v-if="costsCountVisible"></costs-count>
    </div>
  </content-layout>
</template>

<script>
  import { post, fetch } from '../fetch/api'
  import {formatDate} from '../util/filter'

  const costsType = ['房租及中介费', '住宿费', '交通费', '通讯费', '测试费', '车辆租赁费', '车辆使用费', '办公费', '生活用品费', '过路过桥费', '设备购置费', '设备租赁费', '零星材料费', '团队建设费', '燃油费', '搬运费', '其他费用']

  const checkPrice = (rule, value, callback) => {
    if (!/^([-|1-9][\d]{0,7}|0)(\.[\d]{1,10})?$/.test(value)) {
      callback(new Error('金额格式错误！'))
    } else {
      callback()
    }
  }
  const formData = {
    'id': 0,
    'occur_at': null,
    'price': null,
    'description': null,
    'type': null
  }
  export default {
    name: 'CostsPage',
    components: {
      CostsCount: resolve => { require(['../components/CostsCountComponent'], resolve) },
      Loading: resolve => { require(['../components/LoadingComponent'], resolve) },
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    data () {
      let data = []

      for (let i = 0; i <= 360; i++) {
        let t = i / 180 * Math.PI
        let r = Math.sin(2 * t) * Math.cos(2 * t)
        data.push([r, i])
      }

      return {
        formItem: JSON.parse(JSON.stringify(formData)),
        filterItem: {
          'type': 'all',
          'department_id': [],
          'occur_at': null
        },
        tabs: [],
        timeOptions: {
          shortcuts: [
            {
              text: '今天',
              value () {
                return new Date()
              }
            }
          ]
        },
        activeTab: '/costs',
        costsType: costsType,
        title: '费用报备',
        spinShow: false,
        headImage: '/static/images/bg/money.jpeg',
        ruleData: {
          occur_at: [
            {required: true, type: 'date', message: '请选择时间', trigger: 'change'}
          ],
          price: [
            {required: true, message: '请输入金额', trigger: 'change'},
            {validator: checkPrice, trigger: 'blur'}
          ],
          type: [
            {required: true, message: '请选择类型', trigger: 'change'}
          ],
          description: []
        },
        costs: [],
        costsAll: [],
        costsAllTips: '',
        costsTips: '',
        costsCountVisible: false,
        page: {
          total: 0,
          page: 0
        },
        allPage: {
          total: 0,
          page: 1
        },
        dateOptions: {
          shortcuts: [
            {
              text: '一周',
              value () {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                return [start, end]
              }
            },
            {
              text: '上月',
              value () {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                return [start, end]
              }
            },
            {
              text: '前3个月',
              value () {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                return [start, end]
              }
            }
          ]
        }
      }
    },
    watch: {
      '$store.state.userInfo' () {
        this.setTabs()
      },
      $route (to) {
        this.routeChange(to)
      }
    },
    mounted () {
      this.routeChange(this.$route)
      setTimeout(() => {
        this.getDepartment()
        this.setTabs()
      }, 400)
    },
    methods: {
      routeChange (route) {
        let action = route.params.action
        if (action === undefined) {
          this.activeTab = '/costs'
          this.fetchCosts()
        } else if (action === 'all') {
          this.activeTab = '/costs/all'
          this.fetchCostsAll()
        } else if (action === 'post') {
          this.activeTab = '/costs/post'
        } else if (action === 'count') {
          this.activeTab = '/costs/count'
          this.costsCountVisible = true
        }
      },
      fetchCosts () {
        this.spinShow = true
        this.costs = []
        this.costsTips = '加载中请稍等...'
        let params = {
          page: this.page.page
        }
        fetch('costs', {params: params}).then(res => {
          if (res.data.length > 0) {
            this.costs = res.data
            this.page.total = res.total
          } else {
            this.costsTips = '暂无' + (this.filterItem.type === 'all' ? '' : '[' + this.filterItem.type + ']') + '申报记录'
          }
          this.spinShow = false
        }).catch(() => {
          this.costsTips = '加载失败，请重试'
          this.spinShow = false
        })
      },
      fetchCostsAll () {
        this.spinShow = true
        this.costsAll = []
        this.costsAllTips = '加载中请稍等...'
        let params = JSON.parse(JSON.stringify(this.filterItem))
        params.page = this.allPage.page
        if (params.occur_at !== null) {
          params.occur_at = JSON.stringify(params.occur_at)
          params.occur_at = params.occur_at.replace('["",""]', '')
          params.occur_at = params.occur_at.replace('[null,null]', '')
        }
        if (params.department_id !== null) params.department_id = JSON.stringify(params.department_id)

        fetch('costs/all', {params: params}).then(res => {
          if (res.data === 0) {
            this.costsAllTips = '暂无' + (this.filterItem.type === 'all' ? '' : '[' + this.filterItem.type + ']') + '申报记录'
          } else {
            this.costsAll = res.data
            this.allPage.total = res.total
          }
          this.spinShow = false
        }).catch(() => {
          this.costsAllTips = '加载失败，请重试'
          this.spinShow = false
        })
      },
      getDepartment () {
        if (this.$store.state.department.length === 0) this.$store.dispatch('setDepartment', false)
      },
      setDepartment (data) {
        if (typeof data !== 'undefined') return JSON.parse(data)
      },
      outTime (time) {
        return formatDate(time)
      },
      formatTime (time) {
        let tmp = time.split(' ')
        return tmp[0]
      },
      formatDepartment (data) {
        if (!data) return null
        // data = JSON.stringify(data)
        return data.join('>')
      },
      submitCosts (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            post('costs/add', this.formItem).then(res => {
              if (res.status === 'ok') {
                this.$Message.success('添加成功')
                this.activeTab = 'lists'
                this.fetchCosts()
                // this.formItem = JSON.parse(JSON.stringify(formData))
                this.$refs[name].resetFields()
              }
            })
          }
        })
      },
      setTabs () {
        if (this.$menu.isPower('cost', 'all')) this.fetchCostsAll()
        this.tabs = [
          {'title': '我的申报', 'key': '/costs', 'visible': true},
          {'title': '在线申报', 'key': '/costs/post', 'visible': true},
          {'title': '申报记录', 'key': '/costs/all', 'visible': this.$menu.isPower('cost', 'all')},
          {'title': '汇总', 'key': '/costs/count', 'visible': this.$menu.isPower('cost', 'all')}
        ]
      },
      filterCosts () {
        this.fetchCostsAll()
      },
      pagerAllChange (page) {
        this.allPage.page = page
        this.fetchCostsAll()
      },
      pagerChange (page) {
        this.page.page = page
        this.fetchCosts()
      }
    }
  }
</script>

<style scoped>
  .cost-row{
    padding: 10px 0 5px;
    border-bottom:1px solid #eee
  }
</style>
